import { trace } from 'owa-trace';

// Global registry for external signout cleanup functions
// This allows owa-signout to register its cleanup without creating circular dependencies
let externalSignoutCleanup: (() => Promise<void>) | null = null;

/**
 * Registers an external signout cleanup function.
 * This is used by owa-signout package to register its comprehensive cleanup logic.
 */
export function registerExternalSignoutCleanup(cleanup: () => Promise<void>): void {
    externalSignoutCleanup = cleanup;
}

/**
 * Performs signout cleanup operations for MSAL-specific scenarios.
 *
 * Executes the external cleanup registered by owa-signout (via
 * registerExternalSignoutCleanup) so that cross-module callers such as MSAL
 * Activity Timeout and federated logout run the comprehensive cleanup, without
 * owa-msaljs needing to depend on owa-signout (which would create a cycle).
 */
export async function signoutCleanup(): Promise<void> {
    try {
        if (externalSignoutCleanup) {
            await externalSignoutCleanup();
        }

        trace.info('MSAL signout cleanup completed');
    } catch (error) {
        // Log error but don't throw to avoid breaking the signout flow
        trace.info('MSAL signout cleanup failure: ' + error);
    }
}
